export default __webpack_public_path__ + "static/media/0x70c006878a5a50ed185ac4c87d837633923de296.2c1b8c72.webp";